<template>
  <section class="hero">
    <!-- 背景图轮播 -->
    <div
      class="hero-bg"
      v-for="(s, i) in slides"
      :key="i"
      :class="{ show: i === active }"
      :style="{ backgroundImage: `url(${s.bg})` }"
    ></div>
    <div class="hero-mask"></div>

    <div class="hero-inner">
      <!-- 文案轮播 -->
      <transition name="fade" mode="out-in">
        <div :key="active" class="hero-content">
          <div class="hero-tag">{{ slides[active].tag }}</div>
          <h1 class="hero-title">{{ slides[active].title }}</h1>
          <p class="hero-sub">{{ slides[active].subtitle }}</p>

          <div class="hero-points">
            <span v-for="(p, i) in slides[active].points" :key="i" class="hero-point">
              <span class="point-dot" aria-hidden="true"></span>{{ p }}
            </span>
          </div>

          <div class="hero-actions">
            <button class="btn btn-primary" type="button" @click="$router.push('/AboutUs')">了解技明</button>
            <a class="btn btn-ghost" href="tel:13958349372">联系我们</a>
          </div>
        </div>
      </transition>

      <!-- 轮播指示器 -->
      <div class="hero-dots">
        <button
          v-for="(s, i) in slides"
          :key="i"
          type="button"
          class="dot"
          :class="{ active: i === active }"
          :aria-label="`第 ${i + 1} 张`"
          @click="goTo(i)"
        ></button>
      </div>
    </div>

    <!-- 装饰光晕 -->
    <div class="glow glow-a" aria-hidden="true"></div>
    <div class="glow glow-b" aria-hidden="true"></div>
  </section>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from "vue";

const active = ref(0);
let timer = null;

const slides = [
  {
    tag: "智造 · 品质 · 全球",
    title: "家电 / 照明 / 塑料 / 五金\n一体化制造与进出口",
    subtitle:
      "余姚市技明电器有限公司成立于 2009 年，深耕制造加工领域，服务全球客户，从生产到交付提供全链条合作支持。",
    points: ["四大品类制造加工", "支持多元化定制", "自营 + 代理进出口"],
    bg: require("../static/1.webp"),
  },
  {
    tag: "全品类制造能力",
    title: "多品类制造与加工\n满足个性化生产需求",
    subtitle:
      "家用电器、照明灯具、塑料制品、五金件，具备稳定的产能与品质管控能力，配合客户完成从打样到量产的全过程。",
    points: ["成熟生产线", "品质严格把关", "交期稳定可控"],
    bg: require("../static/2.webp"),
  },
  {
    tag: "进出口 · 贸易服务",
    title: "连接中国制造与全球市场\n让合作简单高效",
    subtitle:
      "自营进出口与代理贸易双线并行，帮助国内外客户高效对接优质供应链，让每一次合作都省心、放心。",
    points: ["自营 + 代理双模式", "国内外市场同步覆盖", "从生产到交付全链路"],
    bg: require("../static/4.webp"),
  },
];

function goTo(i) {
  active.value = i;
}

function next() {
  active.value = (active.value + 1) % slides.length;
}

onMounted(() => {
  timer = setInterval(next, 6000);
});

onBeforeUnmount(() => {
  clearInterval(timer);
});
</script>

<style scoped>
.hero {
  position: relative;
  min-height: 560px;
  overflow: hidden;
  background: linear-gradient(120deg, #0a4f97 0%, #0b66bb 55%, #0e7fc9 100%);
}

/* 背景层 */
.hero-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  opacity: 0;
  transform: scale(1.06);
  transition: opacity 1.1s ease, transform 6s ease;
}

.hero-bg.show {
  opacity: 0.38;
  transform: scale(1);
}

.hero-mask {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    100deg,
    rgba(6, 38, 78, 0.9) 0%,
    rgba(8, 58, 116, 0.72) 45%,
    rgba(10, 79, 151, 0.25) 100%
  );
}

.hero-inner {
  position: relative;
  z-index: 2;
  max-width: 1280px;
  margin: 0 auto;
  padding: 88px 24px 60px;
  min-height: 560px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.hero-content {
  max-width: 720px;
}

.hero-tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 16px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  background: rgba(255, 255, 255, 0.12);
  color: #dcebff;
  font-size: 13px;
  letter-spacing: 1px;
  backdrop-filter: blur(6px);
  margin-bottom: 22px;
}

.hero-title {
  font-size: 46px;
  line-height: 1.28;
  font-weight: 800;
  color: #fff;
  margin: 0 0 18px;
  white-space: pre-line;
  text-shadow: 0 4px 18px rgba(4, 26, 54, 0.35);
}

.hero-sub {
  font-size: 16px;
  line-height: 1.9;
  color: rgba(255, 255, 255, 0.88);
  margin: 0 0 24px;
  max-width: 620px;
}

.hero-points {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 22px;
  margin-bottom: 34px;
}

.hero-point {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 13.5px;
  color: rgba(255, 255, 255, 0.9);
}

.point-dot {
  width: 7px;
  height: 7px;
  border-radius: 99px;
  background: #ffc53d;
}

.hero-actions {
  display: flex;
  gap: 14px;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 0 34px;
  border-radius: 999px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  border: none;
  text-decoration: none;
  transition: transform 0.2s, box-shadow 0.2s, background 0.2s;
}

.btn-primary {
  background: linear-gradient(135deg, #ffc53d, #f5a623);
  color: #17324d;
  box-shadow: 0 10px 26px rgba(245, 166, 35, 0.4);
}

.btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 16px 32px rgba(245, 166, 35, 0.5);
}

.btn-ghost {
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  border: 1.5px solid rgba(255, 255, 255, 0.55);
  backdrop-filter: blur(4px);
}

.btn-ghost:hover {
  background: rgba(255, 255, 255, 0.24);
  transform: translateY(-3px);
}

/* 指示器 */
.hero-dots {
  position: absolute;
  bottom: 26px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 9px;
}

.dot {
  width: 9px;
  height: 9px;
  border-radius: 99px;
  border: none;
  background: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  transition: all 0.25s;
}

.dot.active {
  width: 26px;
  background: #fff;
}

/* 光晕 */
.glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(70px);
  opacity: 0.5;
  pointer-events: none;
}

.glow-a {
  width: 420px;
  height: 420px;
  background: rgba(255, 197, 61, 0.28);
  top: -140px;
  right: -100px;
}

.glow-b {
  width: 380px;
  height: 380px;
  background: rgba(46, 168, 255, 0.35);
  bottom: -160px;
  left: -80px;
}

/* 文案过渡 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.fade-enter-from {
  opacity: 0;
  transform: translateY(18px);
}

.fade-leave-to {
  opacity: 0;
  transform: translateY(-12px);
}

/* 响应式 */
@media (max-width: 860px) {
  .hero,
  .hero-inner {
    min-height: 480px;
  }

  .hero-title {
    font-size: 30px;
  }

  .hero-inner {
    padding-top: 56px;
  }
}

@media (max-width: 520px) {
  .hero-title {
    font-size: 25px;
  }

  .hero-sub {
    font-size: 14px;
  }

  .btn {
    height: 44px;
    padding: 0 24px;
    font-size: 14px;
  }
}
</style>
